import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TransferFormComponent } from '../transfer-form/transfer-form.component';
import { OrderResponse } from '../../../models/orders/order.model';

@Component({
  selector: 'app-transfer-form-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    CommonModule,
    TransferFormComponent,
  ],
  templateUrl: './transfer-form-dialog.component.html',
  styleUrl: './transfer-form-dialog.component.scss'
})
export class TransferFormDialogComponent {

  isLoading:boolean = false;
  orders!: OrderResponse[];

  constructor(
    public dialogRef: MatDialogRef<TransferFormDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any
  )
  {
    if(data.orders) {
      this.orders = data.orders;
    }
    else
    {
      this.orders = [];
    }
  }

}
